import React, { useContext, useEffect, useState } from "react";
import AntdTable from "../../../antd/Table/Table";
import { filtrationcontext } from "../../../../context/Filtercontext";
import trans, { isRTL } from "../../../../utils";
import { Tag } from "antd";
import { useReportTableColumns } from "../../ReportColumns/reportColumns";

const DurationReportTable = ({
	startDate,
	endDate,
	currentPage,
	setCurrentPage,
	data,
	isLoading,
}) => {
	//   const { setFileName, setExportIds, setStartDateE, setEndDateE } =
	//     useContext(exportContext);
	const {
		setSort: SetSortFilter,
		limit,
		setLimit,
	} = useContext(filtrationcontext);
	const [sort, setSort] = useState({
		by: "",
		order: "",
	});

	useEffect(() => {
		return () => {
			SetSortFilter({ type: "", value: "" });
			localStorage.setItem("page", 1);
		};
	}, [SetSortFilter]);

	const columns = [
    {
      title: trans("Task ID"),
      dataIndex: "taskCode",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
      render: (taskCode) => (
        <span className={"table-element-name ps-0"}>{taskCode}</span>
      ),
    },
    {
      title: trans("Task Name"),
      dataIndex: "taskName",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Assignee To"),
      dataIndex: "assignedTo",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Customer Location"),
      dataIndex: "poiName",
      width: 150,
    },

    {
      title: trans("Planned Duration (hrs)"),
      dataIndex: "plannedDuration",
      width: 220,
      sorter: true,
      render: (_, record) => record?.formattedPlanned || "0",
    },
    {
      title: trans("Actual Duration (hrs)"),
      dataIndex: "actualDuration",
      width: 220,
      sorter: true,
      render: (_, record) => record?.formattedActual || "0",
    },
    {
      title: trans("Variance (hrs)"),
      dataIndex: "variance",
      width: 150,
      sorter: true,
      render: (_, record) => record?.formattedVariance || "0",
    },
    {
      title: `${trans("Variance")}(%)`,
      dataIndex: "variancePercentage",
      width: 150,
      sorter: true,
      render: (_, record) => (
        <div className="d-flex align-items-center">
          {record?.formattedVariancePercentage[0] === "-" ? (
            <>
              <img
                src={`${process.env.PUBLIC_URL}/assets/New/Randoms/DoubleCheck.svg`}
                alt="doublecheck"
                className={!isRTL ? `me-2` : `ms-2`}
              />

              <div>{record?.formattedVariancePercentage || "0"}</div>
            </>
          ) : (
            <>
              <img
                src={`${process.env.PUBLIC_URL}/assets/New/Randoms/Alert.svg`}
                alt="alert"
                className={!isRTL ? `me-2` : `ms-2`}
              />
              <div>{record?.formattedVariancePercentage || "0"}</div>
            </>
          )}
        </div>
      ),
    },

    {
      title: trans("status"),
      dataIndex: "statusIndicator",
      width: 150,
      render: (statusIndicator) => (
        <Tag
          color={statusIndicator === "On Time" ? "green" : "red"}
          className="text-capitalize"
        >
          {statusIndicator === "On Time" ? trans("On Time") : trans("Overdue")}
        </Tag>
      ),
    },
  ];
	const visibleColumns = useReportTableColumns(columns);

	//   useEffect(() => {
	//     if (data) {
	//       setFileName("Summary Report");
	//       setExportIds(selectedids);
	//       setStartDateE(startDate);
	//       setEndDateE(endDate);
	//     }
	//   }, [data, startDate, endDate, selectedids]);

	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			SetSortFilter({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			SetSortFilter({
				by: "",
				order: "",
			});
		}
	};

	return (
		<div className="bg-white-rounded-top mt-3 table-parent">
			<AntdTable
				columns={visibleColumns}
				dataSource={data?.tasks || []}
				loading={isLoading}
				pageSize={limit}
				totalItems={data?.totalResults || 0}
				currentPage={currentPage}
				onPageChange={(page) => setCurrentPage(page)}
				onLimitChange={(newLimit) => {
					setLimit(newLimit);
					setCurrentPage(1);
				}}
				onTableChange={handleTableChange}
				scrollY={350}
			/>
		</div>
	);
};

export default DurationReportTable;
